import {Component, HostBinding, Input} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-chevron-icon',
    templateUrl: './chevron-icon.component.html',
    styleUrls: ['./chevron-icon.component.scss']
})
export class ChevronIconComponent extends AbstractIcon {
    @HostBinding('style.transform') public transform: string;

    constructor() {
        super();

        this.direction = 'right';
        this.height = 24;
        this.width = 14;
    }

    @Input()
    public set direction(direction: string) {
        if (direction) {
            switch (direction) {
                case 'down':
                    this.transform = 'rotate(90deg)';
                    break;
                case 'left':
                    this.transform = 'rotate(180deg)';
                    break;
                case 'up':
                    this.transform = 'rotate(-90deg)';
                    break;
                default:
                    this.transform = 'rotate(0deg)';
            }
        }
    }
}
